import { IconChevronChevronDown } from '@doltech/icons/IconChevronChevronDown';
import { IconChevronChevronUp } from '@doltech/icons/IconChevronChevronUp';
import { motion } from 'framer-motion';
import * as React from 'react';
import styled from 'styled-components';

import { Button } from '../ButtonV2/ButtonV2';

const CollapseExpandContainer = styled.section``;

const CollapseExpandView = styled.div``;

const CollapseExpandToggle = styled.div`
  position: relative;
  float: right;
  margin-left: 16px;
  width: 40px;
  height: 40px;

  .collapse-expand-toggle {
    position: absolute;
    z-index: 1;
  }
`;

const ExpandedPanel = styled(motion.div)``;
const CollapsedPanel = styled(motion.div)``;

interface CollapseExpandPanelProps extends React.HTMLAttributes<HTMLDivElement> {
  onToggleCollapse?: () => void;
  expand?: boolean;
  collapsedSection?: React.ReactNode;
  expandedSection?: React.ReactNode;
}

const PANEL_ANIMATION_PROP = {
  visible: { opacity: 1, height: 'auto', overflow: 'visible' },
  hidden: { opacity: 0, height: 0, overflow: 'hidden' },
};

export const CollapseExpandPanel = (props: CollapseExpandPanelProps) => {
  const {
    onToggleCollapse = () => {},
    expand = false,
    className,
    collapsedSection,
    expandedSection,
    ...rest
  } = props;

  return (
    <CollapseExpandContainer className={className} {...rest}>
      <CollapseExpandToggle className="collapse-expand-toggle-wrapper">
        <Button.Icon
          type="secondary"
          variant="transparent"
          className="collapse-expand-toggle"
          onClick={onToggleCollapse}
        >
          {expand ? <IconChevronChevronUp /> : <IconChevronChevronDown />}
        </Button.Icon>
      </CollapseExpandToggle>

      <CollapseExpandView>
        <ExpandedPanel
          layout
          variants={PANEL_ANIMATION_PROP}
          transition={{ duration: 0.4 }}
          initial="hidden"
          animate={expand ? 'visible' : 'hidden'}
        >
          {expandedSection}
        </ExpandedPanel>
        <CollapsedPanel
          layout
          variants={PANEL_ANIMATION_PROP}
          transition={{ duration: 0.4 }}
          initial="visible"
          animate={!expand ? 'visible' : 'hidden'}
        >
          {collapsedSection}
        </CollapsedPanel>
      </CollapseExpandView>
    </CollapseExpandContainer>
  );
};
